module.exports = __webpack_public_path__ + "1d713978.svg";